/**
 * 社員区分のEnum
 */
export const EmploymentStatus = {
  PERMANENT: "PERMANENT", // 社員
  TEMPORARY: "TEMPORARY", // 派遣
  SECONDMENT: "SECONDMENT", // 在籍出向
  OTHER: "OTHER", // その他
};

/**
 * 社員区分のラベルマッピング
 */
export const EmploymentStatusLabels = {
  [EmploymentStatus.PERMANENT]: "社員",
  [EmploymentStatus.TEMPORARY]: "派遣",
  [EmploymentStatus.SECONDMENT]: "在籍出向",
  [EmploymentStatus.OTHER]: "その他",
};

/**
 * 社員区分の選択肢（select用）
 */
export const EmploymentStatusOptions = [
  {
    value: EmploymentStatus.PERMANENT,
    label: EmploymentStatusLabels[EmploymentStatus.PERMANENT],
  },
  {
    value: EmploymentStatus.TEMPORARY,
    label: EmploymentStatusLabels[EmploymentStatus.TEMPORARY],
  },
  {
    value: EmploymentStatus.SECONDMENT,
    label: EmploymentStatusLabels[EmploymentStatus.SECONDMENT],
  },
  {
    value: EmploymentStatus.OTHER,
    label: EmploymentStatusLabels[EmploymentStatus.OTHER],
  },
];

/**
 * 社員区分の選択肢（treeselect用）
 */
export const EmploymentStatusOptionsForTree = EmploymentStatusOptions.map(
  option => ({
    id: option.value,
    label: option.label,
  })
);

/**
 * 社員区分のラベルを取得
 * @param {string} status - 社員区分の値
 * @returns {string} ラベル
 */
export const getEmploymentStatusLabel = status => {
  return EmploymentStatusLabels[status] || status;
};

/**
 * 社員区分が「社員」かどうかを判定
 * @param {string} status - 社員区分の値
 * @returns {boolean}
 */
export const isPermanentEmployee = status => {
  return status === EmploymentStatus.PERMANENT;
};

export default {
  EmploymentStatus,
  EmploymentStatusLabels,
  EmploymentStatusOptions,
  EmploymentStatusOptionsForTree,
  getEmploymentStatusLabel,
  isPermanentEmployee,
};

